import type { ThemePreferenceAdapter } from "@takt/web-ui/theme"
import { api } from "@/app/api"

export const adminThemePreferenceAdapter: ThemePreferenceAdapter = {
    async read() {
        const settings = await api.getCurrentUserSettings()
        return settings.theme
    },
    async write(preference) {
        const settings = await api.updateCurrentUserSettings({ theme: preference })
        return settings.theme
    },
}
